// dependencies.
import { get } from 'lodash'

const LOGIN_TO_PATIENT = get(process.env, 'LOGIN_TO_PATIENT')

/**
 * Login para patient route
 */
export default LOGIN_TO_PATIENT



// WEBPACK FOOTER //
// ./src/plugins/http/patient.js